import actionTypes from '../actions/lvm-sales-history/action-types';

const initialState = {
  data: [],
  isLoading: false,
  total: [],
};
export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_LVM_SALES_HISTORY_REQUEST:
    case actionTypes.FETCH_LVM_SALES_HISTORY_FAILURE:
      return {
        ...state,
        isLoading: action.isLoading,
      };
    case actionTypes.FETCH_LVM_SALES_HISTORY_SUCCESS:
      return {
        ...state,
        isLoading: action.isLoading,
        data: action.data,
      };
    case actionTypes.FETCH_LVM_SALES_SUCCESS:
      return {
        ...state,
        isLoading: action.isLoading,
        total: action.total,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/lvm-sales-history.reducer.js